import { get } from 'lodash';

export const actionsByDomainSelector = state => get( state, 'actions.byDomain', {} );
export const actionsIsLoadingSelector = state => get( state, 'actions.isLoading', false );
